import { Link } from 'src/common/types/Link.ts';
import { CellValue } from 'src/common/types/CellValue.ts';

export function isLink(value: CellValue): value is Link {
    return !!value && typeof value === 'object' && 'hyperlink' in value;
}
